import React, { useEffect, useState } from 'react';
import ProfileCard from '../../generic-components/profile/ProfileCard';
import ClayCard from '@clayui/card';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import CutButton from '../../generic-components/customCutButton/CutButton';
import ClayLayout from '@clayui/layout';
import TabComponent from '../../generic-components/customTabNavigation/TabNavigation';
import {
    customerVisibleTabs,
    meetingListTableColumn,
    scopeKey
} from '../../config';
import CustomTable from '../../generic-components/customTable/CustomTable';
import NoDataFound from '../../generic-components/NoDataFound/NoDataFound';
import { useApiMutation } from '../../apis/useApi';
import { ApiResponse } from '../Application/ApplicationList';
import dayjs, { Dayjs } from 'dayjs';

export const meetingListDummyData = [
    {
        meetingTpye: 'Online',
        lastUpdated: '2025-01-15',
        status: 'Scheduled',
        action: 'View'
    },
    {
        meetingTpye: 'Online',
        lastUpdated: '2025-01-10',
        status: 'Completed',
        action: 'Details'
    },
    {
        meetingTpye: 'Online',
        lastUpdated: '2025-01-19',
        status: 'In Progress',
        action: 'Edit'
    },
    {
        meetingTpye: 'Online',
        lastUpdated: '2025-01-21',
        status: 'Cancelled',
        action: 'View'
    }
];

function Home() {
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [active, setActive] = useState(0);
    const [startIndex, setStartIndex] = useState(0);
    const navigate = useNavigate();
    const [meetingTableData, setMeetingTableData] = useState<any[]>([]);
    const handleView = (detail: any) => {
        navigate(`/application-detail/${detail?.id}`);
    };
    const handlePageChange = (page: number) => {
        setStartIndex(page);
    };
    const emailAddress = (
        window as any
    )?.Liferay.ThemeDisplay.getUserEmailAddress();
    const handlePageSizeChange = (size: number) => {
        setPageSize(size);
        setStartIndex(0);
    };
    const getMeetingData = useApiMutation<ApiResponse, {}>(
        `o/c/matchmakingrequestors/scopes/${encodeURIComponent(scopeKey)}`,
        'get',
        {
            onSuccess: (data) => {
                if (data) {
                    const formatted = data?.items?.map((item: any) => ({
                        id: item?.id,
                        companyName: item?.requestorBusinessName,
                        // requestedService: 'Qualification Meeting',
                        meetingDate: dayjs(item?.requestorSelectedSlot)
                            .local()
                            .format('DD/MM/YYYY hh:mm A'),
                        // status: item?.meetingStatus?.name ?? '-',
                        requestId: item?.id
                    }));
                    setMeetingTableData(formatted);
                    setTotalItems(data?.totalCount);
                    setIsLoading(false);
                }
            },
            onError: (error: any) => {
                setIsLoading(false);
                console.error('Mutation error:', error);
            }
        }
    );

    useEffect(() => {
        let meetingStatusFilter = '';
        const now = new Date().toISOString();

           if (active === 1) {
               // Upcoming
               meetingStatusFilter = ` and requestorSelectedSlot gt ${now}`;
           } else if (active === 2) {
               // Completed
               meetingStatusFilter = ` and requestorSelectedSlot lt ${now}`;
           }

        getMeetingData.mutate({
            data: {},
            params: {
                p_auth: (window as any)?.Liferay?.authToken,
                filter: `requestorWorkEmail eq '${emailAddress}' and requestorSelectedSlot ne null${meetingStatusFilter}`,
                sort: 'requestorSelectedSlot:asc',
                restrictFields: 'actions'
            }
        });
    }, [pageSize, currentPage, active]);
    return (
        <>
            <ClayLayout.ContentSection className="button-group-container mt-0 mb-4">
                <CutButton
                    title="Create New Request"
                    buttonType="button"
                    disabled={isLoading}
                    onClick={() => navigate(`/create-request`)}
                />
            </ClayLayout.ContentSection>
            <div className="customer-profile-wrapper">
                <ClayCard className="sidebar-card topBottomCut p-4">
                    <ClayCard.Body className="p-0">
                        <ProfileCard />
                    </ClayCard.Body>
                </ClayCard>
                <div
                    className="pl-4  mt-4 customer-table-tabs-container"
                    style={{ backgroundColor: '#f6f9fa' }}
                >
                    <TabComponent
                        active={active}
                        setActive={setActive}
                        visibleTabs={customerVisibleTabs}
                    />
                </div>
                <div
                    className="p-4 mt-4"
                    style={{ backgroundColor: '#f6f9fa' }}
                >
                    <h5 className="table-title mb-4">
                        Qualification Meeting List
                    </h5>
                    {meetingTableData && meetingTableData?.length > 0 ? (
                        <CustomTable
                            data={meetingTableData || []} // Pass the table data
                            columns={meetingListTableColumn || []} // Pass the columns
                            handleView={handleView} // Pass the handleView function
                            startIndex={startIndex} // Pass the start index for pagination
                            pageSize={pageSize} // Pass the page size
                            onPageChange={handlePageChange} // Pass the function to handle page change
                            onPageSizeChange={handlePageSizeChange} // Pass the function to handle page size change
                            isLoading={isLoading} // Pass loading state
                            totalItems={totalItems}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            isShowPopUp={true}
                        />
                    ) : (
                        <NoDataFound />
                    )}
                </div>
            </div>
        </>
    );
}

export default Home;
